import { userAxios } from '../index'

/**
 * Respuesta estándar: { status, message, data }
 */
export function unwrapData(response) {
  if (response?.status === 'error') {
    const err = new Error(response.message || 'Error en la API')
    err.apiResponse = response
    throw err
  }
  return response?.data
}

export function unwrapList(response) {
  const data = unwrapData(response)
  if (Array.isArray(data)) return data
  if (data?.data && Array.isArray(data.data)) return data.data
  return []
}

export function unwrapPaginated(response) {
  const data = unwrapData(response)
  if (data && Array.isArray(data.data) && data.current_page != null) {
    return {
      items: data.data,
      total: data.total ?? 0,
      current_page: data.current_page,
      from: data.from ?? 0,
      to: data.to ?? 0,
      per_page: data.per_page,
    }
  }
  const list = Array.isArray(data) ? data : []
  return {
    items: list,
    total: list.length,
    current_page: 1,
    from: list.length ? 1 : 0,
    to: list.length,
  }
}

export function getValidationErrors(err) {
  return err?.response?.data?.errors || err?.apiResponse?.errors || null
}

export function getErrorMessage(err) {
  const data = err?.response?.data
  if (data?.message) return data.message
  if (err?.message) return err.message
  return 'Error desconocido'
}

/** Normaliza filtros de listado (omite vacíos; facilities_id como array). */
export function buildListQueryParams(filters = {}) {
  const params = {}
  Object.entries(filters).forEach(([key, value]) => {
    if (value == null || value === '') return
    if (Array.isArray(value) && !value.length) return
    if (key === 'facilities_id') {
      const ids = (Array.isArray(value) ? value : [value])
        .map(v => Number(v))
        .filter(v => Number.isFinite(v))
      if (ids.length) params.facilities_id = ids
      return
    }
    if (typeof value === 'boolean') {
      params[key] = value ? 1 : 0
      return
    }
    if (typeof value === 'string' && value.trim() !== '') {
      if (/^\d+$/.test(value.trim())) {
        params[key] = Number(value.trim())
        return
      }
      params[key] = value.trim()
      return
    }
    if (typeof value === 'number' && Number.isFinite(value)) {
      params[key] = value
      return
    }
    params[key] = value
  })
  return params
}

function wrap(promise) {
  return promise.catch(err => {
    if (err?.response?.data) {
      const e = new Error(getErrorMessage(err))
      e.status = err.response.status
      e.errors = getValidationErrors(err)
      e.responseData = err.response.data
      throw e
    }
    throw err
  })
}

/** Laravel: facilities_id[]=1&facilities_id[]=2 */
function serializeParams(params) {
  if (!params || typeof params !== 'object') return ''
  const parts = []
  Object.entries(params).forEach(([key, value]) => {
    if (value == null || value === '') return
    if (Array.isArray(value)) {
      value.forEach(item => {
        if (item == null || item === '') return
        parts.push(`${encodeURIComponent(key)}[]=${encodeURIComponent(item)}`)
      })
      return
    }
    parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
  })
  return parts.join('&')
}

export const apiGet = (path, params) =>
  wrap(
    userAxios
      .get(path, {
        params,
        paramsSerializer: serializeParams,
      })
      .then(res => res.data)
  )

export const apiPost = (path, body) =>
  wrap(userAxios.post(path, body).then(res => res.data))

export const apiPut = (path, body) =>
  wrap(userAxios.put(path, body).then(res => res.data))

export const apiPutId = (path, id, body) =>
  wrap(userAxios.put(`${path}/${id}`, body).then(res => res.data))

export const apiDelete = path =>
  wrap(userAxios.delete(path).then(res => res.data))
